import Chat_vue_vue_type_script_setup_true_lang_default from "./Chat.vue_vue_type_script_setup_true_lang.js";
//#region src/Chat.vue
var Chat_default = Chat_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Chat_default as default };

//# sourceMappingURL=Chat.vue.js.map